<template>
    <!-- 二维码页面  -->
    <el-dialog :title="popupData.title" :visible.sync="popupData.showPopup" class="player_h5Popup" >
        <ul class="qr_container">
            <li class="qr_wrapper" :id="'qrCode' + index" v-for="(item, index) in popupData.QRarr" :key="item.title" >
                <div class="qr_box" id="qr_box" :style="{backgroundImage: `url(${item.QRBackground})`}">
                    <img v-if="item.src" class="player_h5Popup_qrCode__img" :src="item.src">
                    <p class="player_h5Popup_qrCode__img" v-else>Loading...</p>

                    <div class="player_h5Popup_qrCode__desc">
                        <span class="SysFontM">长按图片扫码</span>
                        <p class="AkrobatR">Press and hold image to scan the QR code</p>
                    </div>
                </div>

                <div class="download_icon" @click="downloadQrcode('qr_box')">
                    <cl-svg-icon icon-class="QR_download" style="color: #fff;font-size: 30px;fill: #fff;"></cl-svg-icon>
                    <p>{{$t("common.下载二维码")}}</p>
                </div>
            </li>
        </ul>

<!--        <img class="player_h5Popup_close" @click="closePopup" src="@assets/images/scoutManage/close-popup.png" alt="">-->
    </el-dialog>
</template>

<script>
    /**
     * ComponentName: 二维码弹窗
     * Created Date:2022/5/10
     * Author: shishuo·zhang
     * Modify:
     * 组件说明：
     * eg:
     *     <cl-qr-code></cl-qr-code>
     */
import {setTimeout} from "timers";
import html2canvas from "html2canvas";

export default {
    name:"cl-qr-code",
    props:{
        popupData:{
            type: Object,
            default:()=>{}
        },
    },
    data(){
        return {  }
    },
    mounted(){

    },
    methods:{

        // 下载二维码
        downloadQrcode(id){
            // this.getQrcode()
            setTimeout(() => {
                html2canvas(document.getElementById(id), {
                    useCORS: true
                }).then(canvas => {
                    const a = document.createElement("a");
                    // 文件名
                    a.download = this.$UIConfig['name' + this.$lang] + ".png";
                    // 设置 a href 属性
                    a.setAttribute("href", canvas.toDataURL("png"));
                    // 触发 a 点击事件
                    a.click();
                    a.remove()
                });
            }, 500);
        },
        // 图片转化base64
        getUrlBase64(url) {
            return  new Promise((resolve) => {
                    let canvas = document.createElement("canvas");
                    let ctx = canvas.getContext("2d");
                    let img = new Image();
                    img.crossOrigin = "Anonymous"; //允许跨域
                    img.src = url;
                    img.onload = function () {
                    canvas.height = 300;
                    canvas.width = 300;
                    ctx.drawImage(img, 0, 0, 300, 300);
                    let dataURL = canvas.toDataURL("image/png");
                    canvas = null;
                    resolve(dataURL);
                };
            });
        },
        //  下载图片
        getQrcode() {
            this.loading = true;
            this.getUrlBase64(this.popupData.src).then((base64) => {
                let a = document.createElement("a");
                a.style.display = "none";
                a.download = this.popupData.title;
                a.href = base64;
                document.body.appendChild(a);
                a.click();
                this.loading = false;
            });
        },
        closePopup(){
            this.popupData.showPopup=false
        }
    }
}
</script>

<style lang="scss" scoped>
.qr_container {
    display: flex;
    .qr_wrapper {
        margin-right: 10px;
        &:last-child {
            margin-right: 0;
        }
        .qr_box {
            width: 270px;
            height: 429px;
            padding-top: 190px;
            border-radius: 14px;
            box-sizing: border-box;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .download_icon {
            margin-top: 16px;
            text-align: center;
            line-height: 20px;
            color: #fff;
            font-size: $base-fontSize-14;
            cursor: pointer;
        }
    }
}
/deep/.el-dialog {
    width: auto;
    background: none;
    background-color: transparent;
    box-shadow: none;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
        .player_h5Popup_qrCode__img {
            display: block;
            width: 120px;
            height: 120px;
            line-height: 120px;
            text-align: center;
            font-size: 14px;
            margin: 0 auto ;
        }
        .player_h5Popup_qrCode__desc {
            margin-top: 32px;
            text-align: center;
            > span {
                color: $base-font-major;
                font-size: $base-fontSize-14;
                line-height: 20px;
            }
            > p {
                margin-top: 6px;
                color: $base-font-tip;
                font-size: $base-fontSize-12;
                line-height: 12px;
            }
        }
    }
}
</style>
